/* global posthog */

export const capturePosthogEvent = (
  eventName,
  properties = {},
  options = {}
) => {
  if (!eventName || typeof posthog === 'undefined') {
    return false;
  }

  try {
    const { sendImmediately = false } = options;

    if (
      typeof posthog.has_opted_out_capturing === 'function' &&
      posthog.has_opted_out_capturing()
    ) {
      return false;
    }

    posthog.capture(
      eventName,
      {
        load_balancer: window.location.hostname,
        $pathname: window.location.pathname,
        $current_url: window.location.href,
        ...properties,
      },
      sendImmediately ? { send_instantly: true } : undefined
    );

    if (sendImmediately && typeof posthog.flush === 'function') {
      posthog.flush();
    }

    return true;
  } catch (error) {
    console.log('[PostHog] capture failed:', eventName, error);
    return false;
  }
};
